import { useMutation } from '@tanstack/react-query';
import FileDownload from 'js-file-download';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { downloadVesselProductsForCustomer } from '../../../common/api/clients/vessel.api';
import { extractFileName } from '../../../common/helpers/extractFileName.helper';
import { translate } from '../../../common/helpers/translate.helper';

export const useVesselProductsCustomerDownload = () => {
    const { addLoadingToast } = useToasts();
    const { mutateAsync: executeVesselProductsDownload } = useMutation({
        mutationFn: downloadVesselProductsForCustomer,
    });

    return async (customerId: string) => {
        return addLoadingToast(
            () =>
                executeVesselProductsDownload(customerId, {
                    onSuccess: (response) =>
                        FileDownload(
                            response.data,
                            extractFileName(response.headers['content-disposition'] || '', 'VesselProducts.xlsx')
                        ),
                }),
            translate('customers.vesselProducts.downloading'),
            translate('customers.vesselProducts.downloadSuccess'),
            translate('customers.vesselProducts.downloadError')
        );
    };
};
